export default __webpack_public_path__ + "static/media/flag-es.8f68f6ec.svg";